module.exports = __webpack_public_path__ + "img/scalability-icon.17560714.svg";